import { styled } from 'baseui'
import { SHAPE, KIND } from 'baseui/button'

import Icons from '@/scenes/Editor/components/Icons'
import ButtonCustom from '@/components/ButtonCustom'
import { SizeButton } from '@/constants/sizeButton'
import { t } from 'i18next'

const Container = styled('div', () => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
}))

interface HistoryControlsProps {
  hasUndo: boolean
  hasRedo: boolean
  disabled?: boolean
  onUndo: () => void
  onRedo: () => void
}

function HistoryControls({ hasUndo, hasRedo, disabled = false, onUndo, onRedo }: HistoryControlsProps) {
  const undoDisabled = !hasUndo || disabled
  const redoDisabled = !hasRedo || disabled

  return (
    <Container
      id="history-actions"
      style={{ pointerEvents: disabled ? 'none' : 'auto' }}
    >
      <ButtonCustom
        style={{ borderRadius: '50%' }}
        onClick={onUndo}
        type={SizeButton.STANDARD}
        kind={KIND.minimal}
        shape={SHAPE.square}
        tooltip={{
          content: t('Undo'),
          placement: 'bottom',
        }}
        disabled={undoDisabled}
      >
        <Icons.Undo size={24} disabled={undoDisabled} />
      </ButtonCustom>
      <ButtonCustom
        style={{ borderRadius: '50%' }}
        onClick={onRedo}
        type={SizeButton.STANDARD}
        kind={KIND.minimal}
        shape={SHAPE.square}
        tooltip={{
          content: t('Redo'),
          placement: 'bottom',
        }}
        disabled={redoDisabled}
      >
        <Icons.Redo size={24} disabled={redoDisabled} />
      </ButtonCustom>
    </Container>
  )
}

export default HistoryControls
